module.exports = __webpack_public_path__ + "img/fail.269822b1.png";